import { useLocation, useNavigate } from "react-router-dom";
import HeaderMenu from "../sidebar/headermenu";
import SettingsTab from "./settings_tab";
import EditProfileForm from "./edit_profile_form";
import { useEffect, useState } from "react";
import { GetSingleUser } from "../../apis/user/get_single_user";
import PlaceHolder from "../../utils/placeholder";
import { API_STATUS } from "../../constants";
import AccSettingHeader from "./acc_setting_header";

export default function EditProfile() {
    const navigate = useNavigate();
    const location = useLocation();

    const [userData, setUserData] = useState("");
    const [userApi, setUserApi] = useState(API_STATUS);

    useEffect(() => {
        const token = sessionStorage.getItem('LOGIN_TOKEN');
        if (token == null) {
            navigate('/login');
        } {
            const userCode = sessionStorage.getItem('USER_CODE');
            GetSingleUser(userCode, setUserApi);

        }
    }, []);

    useEffect(() => {
       // console.log(userApi);
        if (!userApi.isLoader && !userApi.isError && userApi.data !== null) {
             let res = userApi.data;
             setUserData(res['data']);

        }
    }, [userApi]);

    return <div id="wrapper">
        <HeaderMenu />
        <main className="2xl:ml-[--w-side] xl:ml-[--w-side-md] md:ml-[--w-side-small]">
            {
                userData !== "" &&

                <div className="max-w-2xl mx-auto px-1 py-1">
                    <div class="page__heading py-6 mt-6">
                        <a href={'/profile/' + userData['userId']}>
                            <ion-icon name="chevron-back-outline"></ion-icon> Back
                        </a>
                        <h1>Account Settings </h1>
                    </div>

                    <AccSettingHeader userData={userData} activeTab={'edit_profile'}/>

                    <div className="mt-6 mb-20 text-sm font-medium text-gray-600 dark:text-white/80">
                        <div className="uk-switcher bg-white border rounded-xl shadow-sm md:py-12 md:px-20 p-6 overflow-hidden dark:border-slate-700 dark:bg-dark2">
                            <EditProfileForm userData={userData} />
                        </div>
                    </div>
                </div>
            }
            {
                userData.isLoader &&
                <PlaceHolder />
            }
        </main>
    </div>
}